import {
  DATE_RANGE_PRESETS,
  DATE_RANGE_PRESET_OPTIONS,
} from '@components/date-range-preset-filter/constants'

export const AGENT_BILL_PAY_PATH = '/agent-bill-pay'
export const getAgentBillPayBatchPath = (batchId) =>
  `${AGENT_BILL_PAY_PATH}/payment-batches/${batchId}`
export const getAgentBillPayBatchSubmissionPreviewPath = (batchId) =>
  `${getAgentBillPayBatchPath(batchId)}/submission-preview`

export const BILL_PAY_TABS = {
  EXCEPTIONS: 'exceptions',
  PAYMENTS: 'payments',
  TRANSACTIONS: 'transactions',
}

export const BILL_PAY_TAB_OPTIONS = [
  { label: 'Transactions', value: BILL_PAY_TABS.TRANSACTIONS },
  { label: 'Exceptions', value: BILL_PAY_TABS.EXCEPTIONS },
  { label: 'Payments', value: BILL_PAY_TABS.PAYMENTS },
]

export const BILL_PAY_TAB_QUERY_PARAM = 'tab'
export const BILL_PAY_TAB_VALUES = new Set(Object.values(BILL_PAY_TABS))
export const DRAFT_PAYMENT_BATCH_QUERY_PARAMS = { status: 'DRAFT' }
export const EMPTY_ENTITY_LIST = []
export const MAX_PAYMENT_BATCH_NAME_LENGTH = 200
export const PAYMENT_BATCH_INVOICES_DEFAULT_PAGE_SIZE = 10
export const PAYMENT_SUBTABS = {
  PAYMENT_BATCHES: 'payment-batches',
  READY_TO_BATCH: 'ready-to-batch',
}
export const PAYMENT_SUBTAB_QUERY_PARAM = 'paymentTab'
export const PAYMENT_SUBTAB_VALUES = new Set(Object.values(PAYMENT_SUBTABS))

export const INVOICE_DATE_PRESET_OPTIONS = DATE_RANGE_PRESET_OPTIONS.filter(
  ({ value }) => value !== DATE_RANGE_PRESETS.NO_DUE_DATE,
)

const PAYMENT_BATCH_CREATED_DATE_PRESET_VALUES = new Set([
  DATE_RANGE_PRESETS.ALL_DATES,
  DATE_RANGE_PRESETS.THIS_WEEK,
  DATE_RANGE_PRESETS.THIS_MONTH,
  DATE_RANGE_PRESETS.LAST_MONTH,
  DATE_RANGE_PRESETS.THIS_QUARTER,
  DATE_RANGE_PRESETS.Q1,
  DATE_RANGE_PRESETS.Q2,
  DATE_RANGE_PRESETS.Q3,
  DATE_RANGE_PRESETS.Q4,
  DATE_RANGE_PRESETS.CUSTOM,
])

export const PAYMENT_BATCH_CREATED_DATE_PRESET_OPTIONS =
  DATE_RANGE_PRESET_OPTIONS.filter(({ value }) =>
    PAYMENT_BATCH_CREATED_DATE_PRESET_VALUES.has(value),
  )

export const READY_TO_BATCH_DUE_DATE_PRESET_VALUES = new Set([
  DATE_RANGE_PRESETS.THIS_WEEK,
  DATE_RANGE_PRESETS.THIS_AND_NEXT_WEEK,
  DATE_RANGE_PRESETS.NEXT_WEEK,
  DATE_RANGE_PRESETS.NEXT_TWO_WEEKS,
  DATE_RANGE_PRESETS.NEXT_30_DAYS,
  DATE_RANGE_PRESETS.THIS_MONTH,
  DATE_RANGE_PRESETS.NEXT_MONTH,
  DATE_RANGE_PRESETS.LAST_MONTH,
  DATE_RANGE_PRESETS.THIS_QUARTER,
  DATE_RANGE_PRESETS.Q1,
  DATE_RANGE_PRESETS.Q2,
  DATE_RANGE_PRESETS.Q3,
  DATE_RANGE_PRESETS.Q4,
  DATE_RANGE_PRESETS.CUSTOM,
])

export const READY_TO_BATCH_DUE_DATE_PRESET_OPTIONS =
  DATE_RANGE_PRESET_OPTIONS.filter(({ value }) =>
    READY_TO_BATCH_DUE_DATE_PRESET_VALUES.has(value),
  )

export const BILL_PAY_SCROLL_AREA_VIEWPORT_PROPS = {
  'data-testid': 'bill-pay-scroll-area',
  sx: {
    overflowX: 'hidden',
    '& > div': {
      display: 'block !important',
      height: '100%',
      maxWidth: '100%',
      minWidth: '0 !important',
      width: '100%',
    },
  },
}
